"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PricingSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _pricingItems = require("./pricing-items");
var _pricingBox = _interopRequireDefault(require("./pricing-box"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _motionMove = _interopRequireDefault(require("../../../experiments/animation/motion-move"));
const SectionContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SectionContainer",
  class: "pl-syhsu5w"
});
const PricingContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PricingContainer",
  class: "pl-p1239ix6"
});
const Layout = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "Layout",
  class: "pl-lq1y3zq"
});

/**
 * PricingSection component.
 * @module PricingSection
 *
 * @param {Object} props React props
 * @param {string} props._name Tracking name
 * @param {array} props.items pricing boxs data
 * @param {string} props.itemsHeadlineSize Headline size of all Pricing Boxes
 * @param {string} props.itemsHeadlineTag Headline tag of all Pricing Boxes
 * @param {number} props.itemsHeadlineLineLength Headline line length of all Pricing Boxes
 * @param {string} props.verticalMargin Vertical Spacing value
 * @returns {React.ReactElement} PricingSection component
 * @public
 */

function PricingSection({
  items = [],
  _name,
  verticalMargin = 'none',
  itemsHeadlineSize,
  itemsHeadlineTag,
  itemsHeadlineLineLength
}) {
  return /*#__PURE__*/_react.default.createElement(SectionContainer, {
    padding: "none",
    verticalMargin: verticalMargin,
    dataCy: "pricing-section",
    _name: _name || 'pricing-section',
    className: "pricing-section"
  }, /*#__PURE__*/_react.default.createElement(PricingContainer, null, /*#__PURE__*/_react.default.createElement(Layout, {
    mode: "fluid",
    intensity: "300",
    variant: "moveRightFixed",
    staggerChildren: true,
    triggerOnce: true
  }, items.slice(0, 2)?.map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(_pricingBox.default, (0, _extends2.default)({
      key: idx,
      headlineSize: itemsHeadlineSize,
      headlineTag: itemsHeadlineTag,
      headlineLineLength: itemsHeadlineLineLength
    }, item), /*#__PURE__*/_react.default.createElement(_motionMove.default, {
      mode: "fluid",
      intensity: "100",
      variant: "moveUp",
      staggerChildren: true
    }, item.items?.map((pricingFeature, i) => {
      return /*#__PURE__*/_react.default.createElement(_pricingItems.PricingItem, (0, _extends2.default)({
        key: i
      }, pricingFeature));
    })));
  }))));
}
PricingSection.propTypes = {
  _name: _propTypes.default.string,
  items: _propTypes.default.array,
  itemsHeadlineSize: _propTypes.default.string,
  itemsHeadlineTag: _propTypes.default.string,
  itemsHeadlineLineLength: _propTypes.default.number,
  ..._patternLibraryUtils.marginProps
};